import { Wei, SmartContractAction } from '../../utils/types'
import { ceilWei, floorWei } from '../../utils/static-web3'
import { maxGasEstimates } from '../../config'

type CEIL_OR_FLOOR = 'ceil' | 'floor'

export function multiply(
  amount: Wei,
  n: number,
  ceil: CEIL_OR_FLOOR = 'ceil'
): Wei {
  const r = Number(amount) * n
  return ceil === 'ceil' ? ceilWei(r) : floorWei(r)
}

export function add(x: Wei, y: Wei, ceil: CEIL_OR_FLOOR = 'ceil'): Wei {
  const r = Number(x) + Number(y)
  return ceil === 'ceil' ? ceilWei(r) : floorWei(r)
}

export function minus(x: Wei, y: Wei, ceil: CEIL_OR_FLOOR = 'ceil'): Wei {
  const r = Number(x) - Number(y)
  return ceil === 'ceil' ? ceilWei(r) : floorWei(r)
}

export function div(amount: Wei, n: number, ceil: CEIL_OR_FLOOR = 'ceil'): Wei {
  const r = Number(amount) / n
  return ceil === 'ceil' ? ceilWei(r) : floorWei(r)
}

// The web3 contract documentation clearly says gas is a number
// TODO: harmonize & clean the usage of wei / number
export function moreGas(gasInWei: number, action: SmartContractAction): number {
  const minGasAmountInWei: number | undefined = maxGasEstimates.get(action)

  const gasInWeiWithMargin = Math.ceil(gasInWei * 1.1)
  if (
    minGasAmountInWei !== undefined &&
    minGasAmountInWei > gasInWeiWithMargin
  ) {
    return minGasAmountInWei
  }
  return gasInWeiWithMargin
}

export function addSlippage(amount: Wei, slippage: number): Wei {
  return multiply(amount, 1 + slippage, 'ceil')
}

export function removeSlippage(amount: Wei, slippage: number): Wei {
  return multiply(amount, 1 - slippage, 'floor')
}
